/**
 * Connector factory and exports
 *
 * Provides the appropriate connector based on environment configuration
 */

import { DiagramConnector } from "../types";
import { apiConnector } from "./api";
import { mockConnector } from "./mock";

export { ApiConnector, apiConnector } from "./api";
export { MockConnector, mockConnector, DEV_SERVER_URL } from "./mock";

/**
 * Get the appropriate connector based on environment
 *
 * Uses MockConnector by default during development
 * Switch to ApiConnector when VITE_USE_REAL_API is set
 */
export const getConnector = (): DiagramConnector => {
    const useRealApi = import.meta.env.VITE_USE_REAL_API === "true";
    return useRealApi ? apiConnector : mockConnector;
};

/**
 * Default connector instance
 * Can be overridden in tests or specific components
 */
export const defaultConnector = getConnector();
